import { ChatMessage } from 'models/ai-chat/chat.types';
import React from 'react';
import ChatMessageComponent from './chat-message';
import { useChat } from 'store/useChatStore';
import { useAppDispatch } from 'redux/hooks';
import { updateMessageData } from 'features/chat-slice';

interface MessageListProps {
  messages: ChatMessage[];
}

const MessageList: React.FC<MessageListProps> = ({ messages }) => {
  const {feedbackMessageRequest, sendChatMessage} = useChat()
  const dispatch = useAppDispatch();
  
 
  const handleFeedback = (messageId: string, type: 'thumbs_up' | 'thumbs_down') => {
    const feedbackRequest = {
      message_id: messageId,
      feedback_type: type,
      feedback_value: type === 'thumbs_up' ? 'true' : 'false'
    };
    feedbackMessageRequest(feedbackRequest)
  };

  const handleFilterUpdateComplete = (messageId: string, updatedData: any) => {
    dispatch(updateMessageData({
      messageId,
      newData: updatedData
    }));
  };

  const handleMessageEdit = (messageId: string, newContent: string) => {
    // Call the API with edit prefix format
    const editMessage = `[EDIT:${messageId}] ${newContent}`;
    console.log('Sending edit message:', editMessage);
    sendChatMessage(editMessage);
  };

  const handleRegenerateInsights = (messageId: string, originalPrompt: string) => {
    // Find the original user prompt for this assistant message
    const messageIndex = messages.findIndex(msg => msg.message_id === messageId);
    if (messageIndex > 0) {
      // Get the previous message (should be user message)
      const previousMessage = messages[messageIndex - 1];
      if (previousMessage && previousMessage.role === 'user') {
        // Use same method as edit, just change the prefix
        const regenerateMessage = `[REGENERATE:${messageId}] ${previousMessage.content}`;
        console.log('Sending regenerate message:', regenerateMessage);
        sendChatMessage(regenerateMessage);
      }
    }
  };

  return (
    <div className="space-y-6">
      {messages.map((message) => (
        <ChatMessageComponent
          key={message.message_id}
          message={message}
          onFeedback={handleFeedback}
          onMessageEdit={handleMessageEdit}
          onRegenerateInsights={handleRegenerateInsights}
          onVisualizationChange={
           (messageId, newType) => {
              // Handle chart type change
              // console.log(`Message ${messageId} changed to ${newType}`);
            }
          }
          onFilterUpdateComplete={handleFilterUpdateComplete}
        />
      ))}
    </div>
  );
};

export default MessageList;